import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from "react-router-dom"
import { ConfigProvider } from 'antd';
import ViewportProvider from './context/viewport';
import { AuthProvider } from './context/authContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
    <ViewportProvider>
    <AuthProvider>
    <ConfigProvider theme={{ token: { colorPrimary: '#00b96b' } }}>
    <App />
    </ConfigProvider>
    </AuthProvider>
    </ViewportProvider>
    </BrowserRouter>
  </React.StrictMode>
);
